<div class="max-w-full overflow-x-auto">
  <table class="w-full text-sm">
    <colgroup>
      <!-- RECOMENDED TO USE PERCENTAGE WIDTH -->
      <col
        [width]="header.width"
        *ngFor="let header of filteredHeaders"
      />
    </colgroup>
    <tbody>
      <tr class="table-header">
        <th *ngFor="let header of filteredHeaders; let index = index">
          <p [class]="header.Hclasses">
            {{ header.title }}
            <fa-icon
              class="ml-1 cursor-pointer hover:text-primary-lighter"
              *ngIf="
                sorting && header.title && sortingDirection[header.id]
              "
              [icon]="faAngleDown"
              (click)="toggleSort(header.id)"
            />
            <fa-icon
              class="ml-1 cursor-pointer hover:text-primary-lighter"
              *ngIf="
                sorting &&
                header.title &&
                !sortingDirection[header.id]
              "
              [icon]="faAngleUp"
              (click)="toggleSort(header.id)"
            />
          </p>
        </th>
      </tr>
      <tr
        *ngFor="
          let entry of sortEntries(tableEntries, sortingHeader).slice(
            pageSize * pageIndex,
            pageTop
          );
          let index = index
        "
      >
        <td
          *ngFor="let header of filteredHeaders; let subIndex = index"
        >
          <!-- DATA TYPE, JUST A PLAIN AND SIMPLE STRING -->
          <p [class]="header.classes" *ngIf="header.type === 'data'">
            {{ entry[header.id] }}
          </p>
          <!-- LINK TYPE, SPECIFY IN YOUR PARENT COMPONENT THE FUNCTION YOU WISH TO EXECUTE, FROM THIS COMPONENT ITS ONLY RETURNED THE ENTRY DATA AS A OBJECT -->
          <a
            [class]="header.classes"
            (click)="openFunction(entry)"
            *ngIf="header.type === 'link'"
          >
            {{ entry[header.id] }}
          </a>
          <!-- BOOLEAN TYPE, SPECIFY THE TWO VALUES YOU WISH TO REPLACE FOR TRUE/FALSE -->
          <p
            [class]="header.classes"
            class="text-center"
            *ngIf="header.type === 'boolean'"
          >
            {{
              entry[header.id]
                ? header.messages?.[0]
                : header.messages?.[1]
            }}
          </p>
          <!-- EDIT/TRASH TYPE, THIS WILL EXECUTE A FUNCTION SPECIFIED IN YOUR PARENT COMPONENT DEPENDING OF THE BUTTON YOU CLICK ON -->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center gap-x-4 text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'editTrash'"
          >
            <fa-icon
              class="cursor-pointer hover:text-primary-lighter"
              [icon]="faPencil"
              (click)="editFunction(entry)"
            />
            <fa-icon
              class="cursor-pointer hover:text-primary-lighter"
              [icon]="faTrash"
              (click)="removeFunction(entry)"
            />
          </div>
          <!-- TRASH TYPE, THIS WILL EXECUTE A FUNCTION SPECIFIED IN YOUR PARENT COMPONENT -->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'trash'"
          >
            <fa-icon
              class="cursor-pointer hover:text-primary-lighter"
              [icon]="faTrash"
              (click)="removeFunction(entry)"
            />
          </div>
          <!-- EDIT TYPE, SAME AS ABOVE BUT ONLY THE EDIT FUNCTION -->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'edit'"
          >
            <fa-icon
              [icon]="faPencil"
              (click)="editFunction(entry)"
              class="cursor-pointer hover:text-primary-lighter"
            />
          </div>
          <!-- EDIT/PRINT TYPE, THIS WILL EXECUTE A FUNCTION SPECIFIED IN YOUR PARENT COMPONENT DEPENDING OF THE BUTTON YOU CLICK ON -->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center gap-x-4 text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'editPrint'"
          >
            <fa-icon
              class="cursor-pointer hover:text-primary-lighter"
              [icon]="faPencil"
              (click)="editFunction(entry)"
            />
            <fa-icon
              class="cursor-pointer hover:text-primary-lighter"
              [icon]="faPrint"
              (click)="printFunction(entry)"
            />
          </div>
          <!-- READ TYPE, THIS SHOULD OPEN THE ENTRY, LIKE THE LINK OPTION -->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'read'"
          >
            <fa-icon
              [icon]="faInfoCircle"
              (click)="openFunction(entry)"
              class="cursor-pointer hover:text-primary-lighter"
            />
          </div>
          <!-- SAVE TYPE-->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'save'"
          >
            <fa-icon
              [icon]="faSave"
              (click)="saveFunction(entry)"
              class="cursor-pointer hover:text-primary-lighter"
            />
          </div>
          <!-- DOWNLOAD TYPE-->
          <div
            [class]="tableHeaders[subIndex].classes"
            class="flex justify-center text-primary-darker"
            *ngIf="tableHeaders[subIndex].type == 'download'"
          >
            <fa-icon
              [icon]="faDownload"
              (click)="downloadFunction(entry)"
              class="cursor-pointer hover:text-primary-lighter"
            />
          </div>
          <!-- CHECKBOX TYPE, MARKED WHEN VALUE IS TRUE, SIMILAR TO BOOLEAN TYPE -->
          <input
            type="checkbox"
            class="checkbox-table"
            [class]="header.classes"
            *ngIf="header.type == 'checkbox'"
            [checked]="
              isObj(entry[header.id])
                ? entry[header.id]['value']
                : entry[header.id]
            "
            [disabled]="disabledCheckbox(entry, header.id)"
            (click)="checkFunction(entry, header.id)"
          />
        </td>
      </tr>
    </tbody>
  </table>
  <mat-paginator
    #paginator
    *ngIf="pagination"
    class="mt-4"
    (page)="handlePageEvent($event)"
    [length]="tableEntries.length"
    [pageSize]="pageSize"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="pageSizeOptions"
  ></mat-paginator>
</div>
